
export const REG_PHONE = /^1[0-9]{10}$/;
export const REG_NUM = /^(0\.[1-9]\d*|[1-9]\d*(\.\d+)?)$/;
export const REG_AMT = /^\d+(\.\d{0,4})?$/; // 金额规则验证
export const REG_ID_CARD = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/; // 身份证验证
export const REG_P_INT = /^[1-9]\d*$/; // 正整数
export const REG_NUM_N = /^(0|0\.[1-9]\d*|[1-9]\d*(\.\d+)?)$/;
export const REG_T_ZEAR = /^[0-9]\d*$/; // 零和正无穷的整数
export const REG_BARCODE = /^\d{13}$/;// 条形码校验

export default {
  REG_PHONE,
  REG_AMT,
  REG_NUM,
  REG_P_INT,
  REG_ID_CARD,
  REG_NUM_N,
  REG_T_ZEAR,
  REG_BARCODE
};
